<template>
    <b-overlay :show="loading" class="animated">
        <v-server-table
            :columns="table_config.columns"
            :options="table_config.options"
            :theme="theme"
            :ref="ref"
        >
            <span slot="created_at" slot-scope="{ row }">
                {{ formatCreatedAt(row) }}
            </span>
        </v-server-table>
        <NotesForm :data_type="notes_attachable_type" @noteSaved="noteSaved" />
    </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import { ServerTable } from "vue-tables-2";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import NoteCollection from '@/collections/lab/NoteCollection';
import moment from 'moment';
import NotesForm from "./form/NotesForm.vue";
    
Vue.use(ServerTable)

export default {
    name: "NotesDisplay",
    extends: BaseServerTable,
    mixins: [ToastNotifications],
    components: {
    ServerTable,
    NotesForm
},
    props: {
        notes_attachable_type: {
            type: String,
            default: () => null,
        },
        notes_attachable_id: {
            type: String, 
            default: () => null
        },
        collection: {
            type: Object,
            default: () => new NoteCollection(),
        },
        show_columns: {
            type: Array,
            default: () => [
                'note',
                'created_at'
            ],
        },
    },
    data() {
        return {
            table_config: Object.assign(this.getDefaultTableConfig(), {
                options: {
                    headings: {
                        created_at: "Created"
                    },
                    filterable: this.filterable,
                    sortable: this.sortable,
                    debounce: 300,
                },
            }),
            ref: "NoteTable",
        };
    },
    methods: {
        noteSaved() {
            this.$refs.NoteTable.refresh();
        },
        formatCreatedAt(row) {
            return moment(row.created_at).format("ll")
        },
        prepareCollectionFilter(filter) {
            //filter.sortAddDesc("created_at", true);

            filter.filterEquals("notes_attachable_id", this.notes_attachable_id);

            return filter;
        },
    }
};
</script>